import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {cardEntranceFromAbove} from "../../../core/animations/card-entrance.animation";
import {Highlight} from "../models/Highlight";
import {HighlightService} from "../services/highlight.service";

@Component({
  selector: 'cir-pub-highlights',
  templateUrl: './highlights.component.html',
  styleUrls: ['./highlights.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [cardEntranceFromAbove]
})
export class HighlightsComponent implements OnInit {

  @Input() public showArchive: boolean;

  public highlightsLoaded: boolean = false;
  public hasResults: boolean = false;
  public highlights: Array<Highlight> = [];
  private allHighlights: Array<Highlight>;

  public amountToShowOrLoad: number = 10;
  public maxIndexCurrentlyShown: number = 0;
  public moreToShow: boolean = false;

  public errorOccurred: boolean = false;

  constructor(private highlightService: HighlightService) {
  }

  ngOnInit() {
    this.setData();
  }

  public viewMore(): void {
    this.setVisibleHighlights();
  }

  private setData(): void {
    this.highlightService.getHighlights(this.showArchive).subscribe((highlightsData: Highlight[]) => {
      this.allHighlights = highlightsData;
      this.setVisibleHighlights();
      this.highlightsLoaded = true;
      this.hasResults = (this.allHighlights && this.allHighlights.length > 0);
    }, (error) => {
      this.errorOccurred = true;
      console.error("Highlights", error);
    }, () => {

    });
  }

  private setVisibleHighlights(): void {

    // on home page, show _all_ current highlights. On archive page, show all if we're at or less than the amount to load/
    // have visible at a time.
    if (!this.showArchive || (this.allHighlights && this.allHighlights.length <= this.amountToShowOrLoad)) {
      this.highlights = this.allHighlights;
      return;
    }

    if ((this.maxIndexCurrentlyShown + this.amountToShowOrLoad) >= this.allHighlights.length) {
      this.maxIndexCurrentlyShown = this.allHighlights.length;
      this.moreToShow = false;
    } else {
      this.maxIndexCurrentlyShown += this.amountToShowOrLoad;
      this.moreToShow = true;
    }

    this.highlights = this.allHighlights.slice(0, this.maxIndexCurrentlyShown);

  }

}
